import { useEffect, useState } from "react";
import { API_BASE } from "../lib/api";

interface Agent {
  id: string;
  name: string;
  description: string | null;
}

export function AgentPicker({
  token,
  agentId,
  onChange,
}: {
  token: string;
  agentId: string | null;
  onChange: (id: string | null) => void;
}) {
  const [agents, setAgents] = useState<Agent[]>([]);

  useEffect(() => {
    fetch(`${API_BASE}/api/agents`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => setAgents(Array.isArray(rows) ? rows : []))
      .catch(() => setAgents([]));
  }, [token]);

  return (
    <select
      value={agentId ?? ""}
      onChange={(e) => onChange(e.target.value || null)}
      className="max-w-[10rem] rounded border border-border bg-bg px-2 py-1 text-xs"
    >
      <option value="">Standaard agent</option>
      {agents.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name}
        </option>
      ))}
    </select>
  );
}
